function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LocaleKeys from '../../../../../../../locales/keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { INSTANCE_PROPERTY_TYPES, GIFT_CARD_INSTANCE_PROPERTY_NAMES } from '../../../../../../../reducers/constants/products.wizard.constants';
import { REGEXES } from '../../../../../../../customercare.constants';
var EditInstancePropertiesComponentController = /*#__PURE__*/function () {
  /**************************************************************
  * VIEW MODEL DEFINITION ('product' binding)
  * {
  *      -- The product object containing InstanceProperties
  * }
  **************************************************************/

  function EditInstancePropertiesComponentController() {
    _classCallCheck(this, EditInstancePropertiesComponentController);
    Object.assign(this, {
      _instanceProperties: {},
      EMAIL_REGEX_PATTERN: REGEXES.EMAIL,
      GIFT_CARD_INSTANCE_PROPERTY_NAMES: GIFT_CARD_INSTANCE_PROPERTY_NAMES,
      INSTANCE_PROPERTY_TYPES: INSTANCE_PROPERTY_TYPES,
      LocaleKeys: LocaleKeys
    });
  }
  return _createClass(EditInstancePropertiesComponentController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.modelCtrl.$render = function () {
        _this.onRender();
      };
    }
  }, {
    key: "onRender",
    value: function onRender() {
      this._instanceProperties = this.modelCtrl.$viewValue || {};
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged() {
      //Set the view value for ngModel
      this.modelCtrl.$setViewValue(this._instanceProperties);
      this.onChanged() && this.onChanged()();
    }
  }, {
    key: "onTextValueChanged",
    value: function onTextValueChanged(instanceProperty) {
      // don't allow empty strings for text-input instance properties
      if (this._instanceProperties[instanceProperty.Id] === '') {
        delete this._instanceProperties[instanceProperty.Id];
      }
      this.onValueChanged();
    }
  }, {
    key: "getPlaceholder",
    value: function getPlaceholder(instanceProperty, isSelectOption) {
      var result = '';
      if (isSelectOption && !this.hideLabel) {
        result = i18n.translate(this.LocaleKeys.SELECT);
      } else {
        if (this.hideLabel) {
          result = instanceProperty.Name;

          //Double checking hideLabel here as this could be a select input and don't want to modify existing display outside of hideLabel usage.
          if (!instanceProperty.Required && this.hideLabel) {
            var optionalLabel = i18n.translate(this.LocaleKeys.OPTIONAL_LABEL);
            result = "".concat(result, " (").concat(optionalLabel, ")");
          }
          if (this.hideLabel && isSelectOption) {
            var selectLabel = i18n.translate(this.LocaleKeys.SELECT);
            result = "".concat(result, ": ").concat(selectLabel);
          }
        }
      }
      return result;
    }
  }]);
}();
export default {
  template: require('./edit.instance.properties.html'),
  controller: EditInstancePropertiesComponentController,
  require: {
    parentForm: '^^form',
    modelCtrl: 'ngModel'
  },
  bindings: {
    active: '<',
    hideLabel: '<?',
    onChanged: '&',
    product: '<',
    viewOnly: '<'
  }
};